import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_MOTORBIKES, SET_SEARCH_TERM } from 'src/redux/motorbikesReducer'
import { RootReducer } from 'src/redux/rootReducer'
import SearchInput from './SearchInput'

const MotorbikeSearchInput = (): JSX.Element => {
  const dispatch = useDispatch()
  const searchTerm = useSelector((state: RootReducer) => state.motorbikesReducer.searchTerm)

  const handleChange = (value: string): void => {
    dispatch(SET_SEARCH_TERM(value))
    dispatch(FETCH_MOTORBIKES())
  }

  return <SearchInput value={searchTerm} onChange={handleChange} />
}

export default MotorbikeSearchInput
